export const TRUSTPILOT_CONSTANTS = {
  REVIEWS_PER_PAGE_INITIAL: 12,
  REVIEWS_PER_PAGE_LOAD_MORE: 12,
  URL: "https://www.trustpilot.com/review/www.missmary.com",
} as const;
